import { useCompanyGrant } from '@hooks/requests/useCompanyGrant';
import { useUserData } from 'state/userData';

export const useGetDisabledUser = () => {
    const { user, isLoading: isUserDataLoading } = useUserData();
    const companySlug = user?.activeCompany?.slug;

    const {
        data: grant,
        error,
        isLoading,
    } = useCompanyGrant(companySlug ?? null);

    if (isUserDataLoading) {
        return {
            isDisabled: true,
            isLoading: true,
        };
    }

    if (error) {
        return {
            isDisabled: true,
            isLoading,
        };
    }

    return {
        isDisabled: (grant?.is_archived || grant?.is_deleted) ?? true,
        isLoading,
    };
};
